let loaded = false;

/** Load display fonts once for all tenants. */
export function loadHistorywormFonts(_tenant?: string): void {
  if (loaded) {
    return;
  }
  loaded = true;
  require('./historywormFonts');
}

/** Test helper */
export function resetHistorywormFontsForTest(): void {
  loaded = false;
}

export function wasHistorywormFontsLoadedForTest(): boolean {
  return loaded;
}
